import React from 'react';

import PropTypes from 'prop-types';

import { Checkbox } from '@/components/ui/checkbox';
import { CommandGroup, CommandItem } from '@/components/ui/command';

import { AvatarWithName } from '../../../../../shared/components/Avatar';
import { userShape } from '../../../types';

const CreatorList = ({ currentUserId, onToggle, selectedIds, users }) => {
  const buildLabel = (user) =>
    user.id === currentUserId ? `${user.fullName} (me)` : user.fullName;

  return (
    <CommandGroup>
      {users.map((user) => {
        const label = buildLabel(user);

        return (
          <CommandItem key={user.id} onSelect={() => onToggle(user.id)} value={label}>
            <Checkbox checked={selectedIds.includes(user.id)} />

            <AvatarWithName
              avatarColor={user.avatarColor}
              fullName={label}
              initials={user.initials}
            />
          </CommandItem>
        );
      })}
    </CommandGroup>
  );
};

CreatorList.propTypes = {
  currentUserId: PropTypes.string.isRequired,
  onToggle: PropTypes.func.isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  users: PropTypes.arrayOf(userShape).isRequired,
};

export default CreatorList;
